import React, { ComponentProps, forwardRef } from 'react';

import { Link as RouterLink } from 'components/RouterLink';

import { SecondaryButton } from './SecondaryButton';

export const SecondaryButtonRouterLink = forwardRef<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  ComponentProps<typeof SecondaryButton>
>((props, ref) => (
  <SecondaryButton
    component={RouterLink}
    type={undefined}
    ref={ref}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
));
